// this file is generated by update_shopify_store_data.py at 2026-11-03 20:12:47.082155
var courses = [
    {
        "course_id": "13DB7642-2A48-EF11-998E-005056A70840",
        "course_version": 1,
        "name": "ANA: Environmental Infection Control: A Focus on High-Touch Cleaning and Disinfection in the Health Care (Free)",
        "course_type": 1,
        "author_information": "",
        "description": "Overview\r\nThis module focuses on the cleaning and disinfection processes that occur in inpatient areas, including the restroom. High-touch surfaces are emphasized because they are an important focus area for infection prevention and control. When nurses like you focus on the most frequently touched surfaces, you will reduce and lessen the spread of germs and can lower infection risks in the healthcare setting.\r\nHealthcare workers of all professions may also benefit from this course.\r\nWhy is this course important to you?\r\nAccording to the CDC, the environment is one of the most often-overlooked reservoirs for pathogens in the healthcare setting.\u00a0 Awareness and adherence to environmental infection control standards is critical in preventing the spread of a variety of microorganisms.",
        "learning_objectives_html": "Key Learning Outcomes<br />\r\n<br />\r\nDescribe one (1) reason why environmental cleaning and disinfection are important to keep germs from spreading in healthcare settings<br />\r\n<br />\r\nIdentify two (2) high-touch surfaces in healthcare settings",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "18DBACB6-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "01DE6ED9-D88C-EB11-80DF-005056B134EC",
                "course_category_name": "Hand Hygiene",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5EC7EE02-0083-EE11-9986-005056A740BF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            },
            {
                "course_category_id": "306B4D00-C749-E611-832F-005056B17E48",
                "course_category_name": "Environmental Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4FF3BFFA-D08C-EB11-80DF-005056B134EC",
                "course_category_name": "Bloodborne Pathogens",
                "is_system_course_category": null
            },
            {
                "course_category_id": "41A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pharmacology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CD33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Infection Control",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8FAC2CA7-C884-EE11-998F-005056A7C6AF",
                "course_category_name": "ANA - American Nurses Association",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": "ANCC",
            "accreditation_statement": "American Nurses Association is accredited with distinction as a provider of nursing continuing professional development by the American Nurses Credentialing Center's Commission on Accreditation.",
            "course_level_accreditation_statement": "",
            "credit_display_name": "ANCC CNE Credit",
            "credit_units": 1.0,
            "credit_unit_display_name": "ANCC Contact\r\nHour(s)"
        },
        "sub_courses": []
    }
];